import { tw } from '@/utils/tw';
import { default as BaseMoreEpisodes } from 'base/components/MoreEpisodes/theme';

const { List } = BaseMoreEpisodes;

const MoreEpisodes = tw.theme({
  extend: BaseMoreEpisodes,
  slots: {
    headline: ['text-headline-3xs', 'pb-3'],
  },
});

export default Object.assign(MoreEpisodes, { List });
